import _ from "lodash"

import { ReservedFields } from "@/onboarding/features/product/models/Product"

// Screen titles for document fields whose start-cased name does not match the
// wording the rest of the product uses. Everything else falls back to
// startCase, which reads correctly for the plainly-named fields (tour_notes,
// ada_compliant, ...).
//
// The tour form calls these two values a total cost, so the comparison and diff
// tables must too; their field names say "net ratesheet", which users see
// nowhere else. The Complete Details export names them the same way
// (app/forms/exports/tour_library_bulk_export/row_builder.rb).
const FIELD_LABELS: Partial<Record<string, string>> = {
  [ReservedFields.CALCULATED_NET_RATESHEET]: "Calculated Total Cost",
  [ReservedFields.OVERRIDDEN_NET_RATESHEET]: "Overridden Total Cost",
}

export const fieldLabel = (fieldName: string): string =>
  FIELD_LABELS[fieldName] || _.startCase(fieldName)
